var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 1.66602V3.33268",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 1.66602V3.33268",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 2.5H3.33268C2.89065 2.5 2.46673 2.67559 2.15417 2.98816C1.84161 3.30072 1.66602 3.72464 1.66602 4.16667V7.5C1.66602 8.82608 2.1928 10.0979 3.13048 11.0355C4.06816 11.9732 5.33993 12.5 6.66602 12.5C7.9921 12.5 9.26387 11.9732 10.2015 11.0355C11.1392 10.0979 11.666 8.82608 11.666 7.5V4.16667C11.666 3.72464 11.4904 3.30072 11.1779 2.98816C10.8653 2.67559 10.4414 2.5 9.99935 2.5H9.16602",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 12.5C6.66602 13.8261 7.1928 15.0979 8.13048 16.0355C9.06816 16.9732 10.3399 17.5 11.666 17.5C12.9921 17.5 14.2639 16.9732 15.2015 16.0355C16.1392 15.0979 16.666 13.8261 16.666 12.5V10",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.99935C17.5871 9.99935 18.3333 9.25316 18.3333 8.33268C18.3333 7.41221 17.5871 6.66602 16.6667 6.66602C15.7462 6.66602 15 7.41221 15 8.33268C15 9.25316 15.7462 9.99935 16.6667 9.99935Z",
    stroke: "#0C0C0C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor-icon.2d6972e15daa88291f066dd4ab20dd79.svg";
export { ForwardRef as ReactComponent };